module.exports = __webpack_public_path__ + "static/media/icon-mobile-pay.6b1387a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-mobile-pay.svg
// module id = 885
// module chunks = 0